export default "__VITE_ASSET__wsxJi2_t__"